import React from 'react';
import BopisScheduler, { SPIRIT } from './BopisScheduler';

// Washington Spirit BOPIS — match-day store scheduler (spirit_bopis_scheduler.py),
// in the Spirit store's colors.
export default function SpiritBOPIS() {
  return <BopisScheduler team={SPIRIT} />;
}
